/* ============================================================
   MOSAIK — HISTORIQUE  (annuler / refaire)

   Les deux flèches posées sur le plan (#mosaik-stage-tools), au doigt comme à
   la souris. Ce module ne connaît rien du dessin : il photographie l'état du
   plan après chaque action et sait le reposer.

   UNE ENTRÉE = UNE ACTION DU VISITEUR. Une dalle cliquée, un trait entier (pas
   chaque dalle traversée par le doigt ou la souris), un « Remplir tout », un
   « Damier », un remplissage de zone : « Annuler » revient d'un cran, jamais
   de deux. Ce sont les modules du geste qui poussent l'entrée une fois
   l'action appliquée — voir mosaik.commitHistory() dans mosaik-controller.js.

   POURQUOI CE FICHIER S'APPELLE ENCORE « toolbar ». Il portait la barre
   d'outils mobile (rangée d'icônes fixe + popovers), supprimée quand le mobile
   est passé au même shell que le bureau : il ne reste que l'historique, qui y
   vivait déjà. Le NOM DU FICHIER est celui de l'asset déployé
   (mosaik-toolbar2.js, référencé par le template) — le renommer obligerait à
   déployer un asset de plus, pour rien. Le module, lui, s'appelle ce qu'il est.
   ============================================================ */
window.MosaikHistory = {

  m: null,
  _hist: [], _hi: -1,
  MAX: 120,                 // au-delà, les entrées les plus anciennes tombent

  $:function(id){ return document.getElementById(id); },

  setup:function(mosaik){
    const self = this;
    this.m = mosaik;

    /* Rien n'est capté ici. Chaque action est validée par le module qui porte
       le geste, UNE FOIS QU'ELLE EST APPLIQUÉE (mosaik-controller.js pour la
       souris et les remplissages, mosaik-zoom.js pour le tactile) via
       mosaik.commitHistory(). Ce module écoutait autrefois `mouseup` sur le
       plan : cet événement précède le `click` qui peint, l'historique retardait
       donc d'une action et chaque « Annuler » en défaisait deux d'un coup. */

    // un changement de collection ou de cote refait la grille : les entrées
    // d'avant portent des dalles d'une autre géométrie, elles ne sont plus
    // rejouables — on repart de l'état neuf.
    const sel = this.$('mosaik-collection');
    if(sel) sel.addEventListener('change', () => setTimeout(() => self.resetHistory(), 0));
    ['mosaik-area-width','mosaik-area-height'].forEach(id => {
      const el = self.$(id);
      // 'keyup' comme 'change' : le contrôleur vide déjà le plan à la frappe
      if(el) ['change','keyup'].forEach(ev =>
        el.addEventListener(ev, () => setTimeout(() => self.resetHistory(), 0)));
    });

    this.resetHistory();
  },

  /* ---------- capture ---------- */

  /* Empreinte du plan : deux états qui donnent la même chaîne sont le même
     dessin. C'est ce qui permet aux modules du geste de valider sans compter —
     un commit qui n'a rien changé (le `click` qui suit un glissé, par exemple)
     ne crée pas d'entrée. */
  /* Les objets posés sur le plan (mosaik-objects.js) font partie du dessin :
     poser un emplacement de voiture ou le déplacer s'annule comme un coup de
     pinceau. Leur forme sérialisée est déjà compacte et suffit à les rétablir. */
  _objects:function(){
    return (window.MosaikObjects && MosaikObjects.enabled) ? MosaikObjects.serialize() : null;
  },
  _sig:function(){
    const m = this.m;
    return JSON.stringify({
      r: (m.result || []).map(p => p ? (p.name_fr || p.color) : 0),
      b: Object.entries(m.borderAssignments).map(([k, v]) => k + ':' + (v.name_fr || v.color) + ':' + v.side),
      c: Object.entries(m.cornerAssignments).map(([k, v]) => k + ':' + (v.name_fr || v.color)),
      o: this._objects()
    });
  },
  snapshot:function(){
    if(!this.m) return;                                             // avant setup()
    const sig = this._sig();
    if(this._hi >= 0 && this._hist[this._hi].sig === sig) return;    // rien n'a bougé
    this._hist = this._hist.slice(0, this._hi + 1);                  // la branche « refaire » tombe
    this._hist.push({
      sig,
      result:  (this.m.result || []).slice(),
      borders: { ...this.m.borderAssignments },
      corners: { ...this.m.cornerAssignments },
      objects: this._objects()
    });
    // l'état de départ (entrée 0) est le seul qu'on ne puisse pas jeter : c'est
    // le fond sur lequel « Annuler » s'arrête
    if(this._hist.length > this.MAX) this._hist.splice(1, this._hist.length - this.MAX);
    this._hi = this._hist.length - 1;
    this.syncUndoRedo();
  },
  /* Appelé par les modules du geste : « l'action est posée, retiens-la ». */
  commit:function(){ this.snapshot(); },
  resetHistory:function(){ this._hist = []; this._hi = -1; this.snapshot(); },

  /* ---------- restitution ---------- */
  _restore:function(s){
    this.m.result = s.result.slice();
    this.m.borderAssignments = { ...s.borders };
    this.m.cornerAssignments = { ...s.corners };
    if(s.objects && window.MosaikObjects && MosaikObjects.enabled)
      MosaikObjects.restore(this.m, s.objects);
    // ce qui attendait d'être retenu vient d'être remplacé : sinon la fin du
    // geste en cours (un mouseup qui traîne) rangerait l'état restauré comme une
    // action neuve, et « Refaire » serait perdu
    this.m.dirty = false;
    this.m.draw();
  },
  /* Un cran en arrière / en avant : UNE action, jamais deux. */
  undo:function(){ if(this._hi > 0){ this._hi--; this._restore(this._hist[this._hi]); this.syncUndoRedo(); } },
  redo:function(){ if(this._hi < this._hist.length - 1){ this._hi++; this._restore(this._hist[this._hi]); this.syncUndoRedo(); } },

  /* Les flèches sont éteintes quand il n'y a rien à défaire / refaire. Tous les
     [data-act] de la page sont synchronisés : le plan en porte une paire, et
     rien n'interdit d'en poser ailleurs. */
  syncUndoRedo:function(){
    document.querySelectorAll('[data-act="undo"]').forEach(u => { u.disabled = this._hi <= 0; });
    document.querySelectorAll('[data-act="redo"]').forEach(r => { r.disabled = this._hi >= this._hist.length - 1; });
  }
};

/* ---- compatibilité de déploiement ----
   Les assets sont déployés fichier par fichier : un visiteur peut donc avoir en
   cache un mosaik-controller2.js / mosaik-recap2.js d'avant ce changement, qui
   appelle encore l'ancien nom. Trois lignes pour que l'historique tienne le
   temps que tous les fichiers soient à jour, plutôt qu'un configurateur mort. */
window.MosaikToolbar = window.MosaikHistory;
window.MosaikHistory.setupUI  = function(m){ return this.setup(m); };
window.MosaikHistory.onRecalc = function(){};   // portait le total de la barre mobile
